export const MUTATION_KEYS = {
	CHANGE_EMAIL: 'CHANGE_EMAIL',
	CHANGE_PHONE: 'CHANGE_PHONE',
	AUTHENTICATION: 'AUTHENTICATION',
	BENEFICIARY: 'BENEFICIARY',
	SIDEBAR: 'SIDEBAR',
	COMPANY_PORTAL: 'COMPANY_PORTAL',
	B2B_BENEFICIARY_AUTHORIZATION: 'B2B_BENEFICIARY_AUTHORIZATION',
	CONFIRM_REGISTRATION_DATA: 'CONFIRM_REGISTRATION_DATA',
	CONTRACTUAL_TERM_ACCEPT: 'CONTRACTUAL_TERM_ACCEPT',
	RESPOND_ADDRESS_SUGGESTION: 'RESPOND_ADDRESS_SUGGESTION',
	CONFIRM_ADDRESS: 'CONFIRM_ADDRESS',
	VOICE_TRANSCRIPTION_TERMS_ACCEPT: 'VOICE_TRANSCRIPTION_TERMS_ACCEPT',
};
